import React from 'react';
import { Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useDemo } from '../../contexts/DemoContext';
import { workflowStages } from '../../data/sampleCase';
import { toBn } from '../../utils/bangla';
const stageRoutes = ['/admin/upload', '/admin/ocr', '/admin/review', '/admin/validate', '/admin/approval', '/admin/generate', '/admin/dispatch'];
export function WorkflowStepper({
  current
}: {
  current?: number;
}) {
  const {
    stage
  } = useDemo();
  const navigate = useNavigate();
  return <nav aria-label="প্রক্রিয়ার ধাপ" className="mb-6 overflow-x-auto rounded-lg border border-border bg-white px-4 py-3" data-id="element-158" data-mp="3w509i1s3nhon">
      <ol className="flex min-w-[860px] items-center" data-id="element-159" data-mp="er4o2wawytf1">
        {workflowStages.map((s, i) => {
        const done = i < stage;
        const active = current === i;
        return <li key={s.label} className="flex flex-1 items-center last:flex-none" data-id="element-160" data-mp="nnncpwc43v5t" data-mpi={i}>
              <button type="button" onClick={() => navigate(stageRoutes[i])} className="flex items-center gap-2 rounded-md px-1 py-0.5 text-left hover:bg-muted" data-id="element-161" data-mp="is81lc5hodd3">
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${done ? 'bg-[#16834A] text-white' : active ? 'bg-[#003B71] text-white ring-4 ring-[#003B71]/15' : 'bg-slate-100 text-slate-500'}`} data-id="element-162" data-mp="36t5bp59b3var">
                  {done ? <Check className="h-4 w-4" data-id="element-163" data-mp="3kt6l593n0b1u" /> : toBn(i + 1)}
                </span>
                <span className={`whitespace-nowrap text-xs font-medium ${active ? 'text-[#003B71]' : done ? 'text-[#16834A]' : 'text-slate-500'}`} data-id="element-164" data-mp="3prhxprlbgznr">{s.label}</span>
              </button>
              {i < workflowStages.length - 1 && <span className={`mx-2 h-px flex-1 ${done ? 'bg-[#16834A]' : 'bg-slate-200'}`} data-id="element-165" data-mp="3cgdc6jvnrw6" />}
            </li>;
      })}
      </ol>
    </nav>;
}